export default __webpack_public_path__ + "static/media/Foto1.5bcfa08f.png";